/** Pan and zoom for one tab on one campaign. Session only, same idea as Flow. */
const memory = new Map();

export function boardCameraKey(tabId, campaignId) {
  if (!tabId || !campaignId) return null;
  return `${tabId}:${campaignId}`;
}

export function rememberBoardCamera(tabId, campaignId, camera) {
  const key = boardCameraKey(tabId, campaignId);
  if (!key || !camera) return;
  const zoom = Number.isFinite(camera.zoom) && camera.zoom > 0 ? camera.zoom : 1;
  memory.set(key, {
    x: Number.isFinite(camera.x) ? camera.x : 0,
    y: Number.isFinite(camera.y) ? camera.y : 0,
    zoom,
  });
}

export function recallBoardCamera(tabId, campaignId) {
  const key = boardCameraKey(tabId, campaignId);
  if (!key) return null;
  return memory.get(key) || null;
}
